import { useNavigate } from "react-router-dom";
import { EuiFlexGroup, EuiFlexItem, EuiToolTip } from "@elastic/eui";
import LinkToList from "components/Popover/LinkToList";
import { Profile } from "../profileTypes";
import { BellIcon } from "components/Icons";
import { REDIRECT_TO_NOTIFICATION_CHANNELS } from "settings/menu/admin_console";
import { generateExcelFileName } from "utils";

const NotificationChannelLinkToList = ({ profile }: { profile: Profile }) => {
  const navigate = useNavigate();
  const notifcationChannelColumns = [
    {
      field: "severity",
      name: "Severity",
    },
    {
      field: "type",
      name: "Type",
    },
    {
      field: "name",
      name: "Name",
      width: 300,
      render: (name, row) => {
        return (
          <div>
            <strong>{row.channelType}: </strong>
            <span>{name}</span>
          </div>
        );
      },
    },
  ];

  const transformNotificationChannels = (openNC, closeNC) => {
    const openChannels = Array.isArray(openNC) ? openNC : [];
    const closeChannels = Array.isArray(closeNC) ? closeNC : [];

    const transformedOpen = openChannels.flatMap((item) => {
      return item.severityAssignments.map((severityAssignment) => ({
        id: parseInt(`1${item.id}${severityAssignment.id}`),
        severity: severityAssignment.name,
        name: item.name,
        channelType: item.type,
        type: "Open",
      }));
    });

    const transformedClose = closeChannels.flatMap((item) => {
      return item.severityAssignments.map((severityAssignment) => ({
        id: parseInt(`2${item.id}${severityAssignment.id}`),
        severity: severityAssignment.name,
        name: item.name,
        channelType: item.type,
        type: "Close",
      }));
    });

    return [...transformedOpen, ...transformedClose];
  };

  const openChannelsCount = profile?.alertOpenNotificationChannelMappings?.length || 0;
  const closeChannelsCount = profile?.alertCloseNotificationChannelMappings?.length || 0;
  const totalChannelsCount = openChannelsCount + closeChannelsCount;
  const hasNotificationChannelMappings = totalChannelsCount > 0;

  return (
    <LinkToList
      Copy={false}
      Columns={notifcationChannelColumns}
      Items={transformNotificationChannels(
        profile.alertOpenNotificationChannelMappings,
        profile.alertCloseNotificationChannelMappings
      )}
      PopOverMaxWidth={400}
      showExport={true}
      exportFileName={generateExcelFileName(`Profile Notification Channels ${profile.name}`)}
      showHeaders={true}
      ButtonTitle={
        <EuiToolTip content="Assigned notification channels">
          <EuiFlexGroup alignItems="center" gutterSize="s">
            <EuiFlexItem>
              <BellIcon fill={hasNotificationChannelMappings ? "var(--cyan)" : "var(--text)"} />
            </EuiFlexItem>
            <EuiFlexItem
              style={{
                color: "var(--text)",
              }}>
              {totalChannelsCount}
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiToolTip>
      }
      belowButton={{
        name: "View Notification Channels",
        onClick: () => {
          navigate(REDIRECT_TO_NOTIFICATION_CHANNELS);
        },
      }}
    />
  );
};

export default NotificationChannelLinkToList;
